import {Injectable} from "@angular/core";
import {ISelectionReportRecordingStatus} from "./selection-report-summary-status";
import {AudioQueueItem, TranslateAudio} from "../services/audio-playback/audioqueue.item";
import {EventBus} from "../event/EventBus";
import {AudioQueueEvent, InterruptAudio} from "../event/AudioQueueEvent";
import {AudioQueueService} from "../services/audio-playback/audioqueue.service";

@Injectable()
export class SelectionReportAudio {

    constructor(private eventBus: EventBus,
                private audioQueuService: AudioQueueService) {}

    public playInitalAudio(summaryStatus: ISelectionReportRecordingStatus, hasReviewWords: boolean ): void {
        let audios: AudioQueueItem[] = [];

        // gold/silver audio
        if (summaryStatus.designation === "gold" || summaryStatus.designation === "silver")  {
            if (summaryStatus.designation === "gold")  {
                audios.push(new AudioQueueItem("RA_RPT_SEL_05", TranslateAudio.YES));
            } else if (summaryStatus.designation === "silver") {
                audios.push(new AudioQueueItem("RA_RPT_SEL_06", TranslateAudio.YES));
            }

            if (hasReviewWords) {
                audios.push(new AudioQueueItem("RA_RPT_SEL_07", TranslateAudio.YES));
            }
        } else if (summaryStatus.designation === "checkmark" && !hasReviewWords)  {
            // checkmark with no/review words
            audios.push(new AudioQueueItem("RA_RPT_SEL_04", TranslateAudio.YES));
        } else if (summaryStatus.designation === "checkmark" && hasReviewWords)  {
            // checkmark with review words
            audios.push(new AudioQueueItem("RA_RPT_SEL_03", TranslateAudio.YES));
        }

        this.audioQueuService.reset().subscribe(() => {
            this.eventBus.next(new AudioQueueEvent(audios, InterruptAudio.NO));
        });
    }

    public playExitAudio(): void {
        this.audioQueuService.reset().subscribe(() => {
            this.eventBus.next(new AudioQueueEvent([
                new AudioQueueItem("RA_RPT_SEL_01", TranslateAudio.YES)
            ], InterruptAudio.NO));
        });
    }
}
